import { News } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const workingNewsReducer: RemoteReducer<News[]> =
  createRemoteReducer("workingNews")
